import React from 'react';
import { AuthData } from '../../../context/auth';
import {
	EndorsementData,
	withEndorsementContext,
} from '../../../context/EndorsementProvider';
import { Exposure as ExposureType } from '../../../types/policy';
import AddedExposureDetails from './AddedExposureDetails';
import ExistingExposureDetails from './ExistingExposureDetails';

interface Props {
	authData: AuthData;
	endorsementData: EndorsementData;
}

/**
 * The component to render an existing or added exposure detail on an endorsement.
 */
const Exposure = (props: Props) => {
	const { selectedExposure } = props.endorsementData;
	const exposureIsExisting = !!(selectedExposure as ExposureType).displayId;

	if (exposureIsExisting) {
		return <ExistingExposureDetails />;
	} else {
		// exposure was added, meaning perils will all be PerilCreateRequests
		return <AddedExposureDetails />;
	}
};

export default withEndorsementContext<Props>(Exposure);
